import { render } from "./stock.vue?vue&type=template&id=6ce9e950"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
script.render = render

export default script